import Player from '@vimeo/player';

export default (blockdId) => ({
  blockId: blockdId,
  fullVideoPlaying: false,
  turboLoaded: true,
  videoLoaded: false,
  vimeoFull: '',
  options: {
    dnt: true,
  },

  init() {
    const vimeoFullWraper = document.getElementById(
      `vimeo-full-${this.blockId}`
    );
    if (vimeoFullWraper) {
      const vimeoFull = document.getElementById(`vimeo-full-${this.blockId}`)
        .dataset.id;
      const player = this.initVideo(`vimeo-full-${this.blockId}`, {
        id: vimeoFull,
        width: 1087,
        muted: true,
        responsive: true,
        background: true,
        controls: false,
        loop: true,
        ...this.options,
      });
      player.setCurrentTime(20);
      player.play();
      player.on('timeupdate', (data) => {
        if (data.seconds > 1) {
          this.videoLoaded = true;
        }
        if (data.seconds > 24 && !this.fullVideoPlaying) {
          player.setCurrentTime(20);
        }
      });
    }
    for (let index = 1; index < 3; index++) {
      const vimeoSmallWrapper = document.getElementById(`vimeo-small-${index}`);
      if (vimeoSmallWrapper) {
        const vimeoSmallId = vimeoSmallWrapper.dataset.id;
        const videoSmall = this.initVideo(`vimeo-small-${index}`, {
          id: vimeoSmallId,
          width: 348,
          muted: false,
          responsive: true,
          ...this.options,
        });
        videoSmall.on('play', () => {
          this.stopFullVideo();
        });
      }
    }
    document.addEventListener('turbo:load', () => {
      this.turboLoaded = true;
    });
  },

  initVideo(name, options) {
    return new Player(name, options);
  },

  stopFullVideo() {
    this.fullVideoPlaying = false;
    const player = new Player(`vimeo-full-${this.blockId}`);
    player.unload();
    player.setCurrentTime(15);
  },

  playFullVideo() {
    this.fullVideoPlaying = true;
    const player = new Player(`vimeo-full-${this.blockId}`);
    player.unload();
    player.play();
    player.setMuted(false);
    player.setLoop(false);
    player.on('ended', () => {
      if (this.fullVideoPlaying) {
        player.setCurrentTime(15);
        this.fullVideoPlaying = false;
      }
    });
  },
});
